export const BUSINESS_NAME = 'Zinex Softwares';
export const BUSINESS_ADDRESS = '6 Ekatis Close, off Mopo Road, United Estate, Sangotedo, Ibeju Lekki Area, Lagos';
export const BUSINESS_EMAIL = 'licenses@zinexsoftwares.org';
export const BUSINESS_LOGO = '/logo.jpeg';
